import React from 'react'
import { Button, Stack } from '@mui/material'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

interface RecordNavigationButtonsProps {
  previousId: number | null
  nextId: number | null
  onNavigate: (id: number) => void
  loading?: boolean
}

export const RecordNavigationButtons: React.FC<RecordNavigationButtonsProps> = ({
  previousId,
  nextId,
  onNavigate,
  loading = false
}) => {
  return (
    <Stack direction="row" spacing={1}>
      <Button
        variant="outlined"
        startIcon={<NavigateBeforeIcon />}
        disabled={previousId === null || loading}
        onClick={() => { if (previousId !== null) onNavigate(previousId) }}
        aria-label="Previous record"
      >
        Previous
      </Button>
      <Button
        variant="outlined"
        endIcon={<NavigateNextIcon />}
        disabled={nextId === null || loading}
        onClick={() => { if (nextId !== null) onNavigate(nextId) }}
        aria-label="Next record"
      >
        Next
      </Button>
    </Stack>
  )
}
